export const dateTimeFormat = 'MM/dd/yyyy h:mm:ss aa z';
